module.exports = __webpack_public_path__ + "media/images/house-svgrepo-com (1)-7dc65dda0270d3048604251b6450db2f.svg";